
import {Component, Vue} from 'vue-property-decorator'
import UserGroupInfo from '@/model/modules/UserGroupInfo'
import CourierService from '@/service/modules/CourierService'
import BasePageableInfo from '@/model/modules/BasePageableInfo'
import CourierInfo from '@/model/modules/CourierInfo'

@Component
export default class UserGroupCourierEditor extends Vue {
  item: UserGroupInfo = new UserGroupInfo()
  showState: boolean = false
  savingState: boolean = false
  saveSuccessCallback: any
  dataLoadingState: boolean = false

  allCourierList: CourierInfo[] = []
  selectedCourier: { [index: number]: boolean } = {}

  mounted() {
    CourierService.list({}, 0, 999999)
      .then((result: BasePageableInfo<CourierInfo>) => {
        this.allCourierList = result.dataList
      })
  }

  showEditor(item: UserGroupInfo, saveSuccessCallback: any) {
    this.item = JSON.parse(JSON.stringify(item))
    this.saveSuccessCallback = saveSuccessCallback
    this.showState = true
    this.selectedCourier = {}
    this.dataLoadingState = true
    this.allCourierList.forEach((courier: CourierInfo) => {
      this.selectedCourier[courier.id] = false
    })
    CourierService.listWithUser({groupId: this.item.id}, 0, 999999)
      .then((resp: BasePageableInfo<CourierInfo>) => {
        resp.dataList.forEach((courier: CourierInfo) => {
          Vue.set(this.selectedCourier, courier.id, true)
        })
        this.dataLoadingState = false
      })
  }

  saveEditor() {
    this.savingState = true
    const selectedIds: number[] = []
    for (const courierId in this.selectedCourier) {
      if (this.selectedCourier[courierId]) {
        selectedIds.push(Number(courierId))
      }
    }
    CourierService.saveGroupCourier(this.item.id, selectedIds)
      .then(() => {
        this.$alert('保存数据', '保存成功', {
          confirmButtonText: '确定'
        })
        this.savingState = false
        this.showState = false
        this.saveSuccessCallback()
      })
  }
}
